import { render, staticRenderFns } from "./sepacilatiesStatistics.vue?vue&type=template&id=415e5238&scoped=true"
import script from "./sepacilatiesStatistics.vue?vue&type=script&lang=js"
export * from "./sepacilatiesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e5238",
  null
  
)

export default component.exports